import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AppleMusic from '../views/AppleMusic.vue'
import Spotify from '../views/Spotify.vue'
import Callback from '../views/Callback.vue'
import YTBIOADB from '../views/YTBIOADB.vue'
import RROOB from '../views/RROOB.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }, {
    path: '/apple',
    name: 'AppleMusic',
    component: AppleMusic
  }, {
    path: '/spotify',
    name: 'Spotify',
    component: Spotify,
  }, {
    path: "/ytbioad",
    name: "YTBIOADB",
    component: YTBIOADB
  },
  {
    path: "/rroob",
    name: "RROOB",
    component: RROOB
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  }, {
    // path: "*",
    path: "/:catchAll(.*)",
    redirect: '/',
    meta: {
      requiresAuth: false
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
